// localStorage keys
export const THEME = "client-portal-theme";
export const REMEMBERED_EMAIL = "client-portal-remembered-email";

export const BUILD_VERSION_CONFIG = "client-portal-build-version-key-key";

// cookie keys
export const USER_ID = "client-portal-user-id";
export const HASHED_PASSWORD = "client-portal-hashed-password";
export const AUTH_DATA = "client-portal-auth-data";
export const SELECTED_TENANT_ID = "client-portal-selected-tenant-id";
export const AUDIT_ADVANCED_SEARCH = "client-portal-audit-advanced-search";

//sessionStorage keys

export const ADMIN_COLLABORATOR_SEARCH_QUERY = "client-portal-admin-collaborator-search-query";
export const CLIENT_COLLABORATOR_SEARCH_QUERY = "client-portal-client-collaborator-search-query";
export const ADMIN_ORGANIZATION_HISTORY_SEARCH_QUERY =
  "client-portal-admin-organization-history-search-query";
export const ADMIN_API_KEYS_SEARCH_QUERY = "client-portal-admin-api-keys-search-query";
export const CLIENT_API_KEYS_SEARCH_QUERY = "client-portal-client-api-keys-search-query";
